import { render } from "./BlockRateDataCard.vue?vue&type=template&id=1d845a61&scoped=true"
import script from "./BlockRateDataCard.vue?vue&type=script&lang=js"
export * from "./BlockRateDataCard.vue?vue&type=script&lang=js"

import "./BlockRateDataCard.vue?vue&type=style&index=0&id=1d845a61&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d845a61"]])

export default __exports__